import { NETWORK_ERROR, isApiError } from "@/shared/api/errors";
import type { MessageId } from "@/shared/i18n/messages";

/* The server's texts are English; every failure the time screens show comes from the catalog. */
const MESSAGES: Readonly<Partial<Record<string, MessageId>>> = {
  TIME_ENTRY_IN_FUTURE: "time.errors.future",
  TIME_ENTRY_TOO_OLD: "time.errors.tooOld",
  TIME_ENTRY_LENGTH: "time.errors.length",
  TIME_ENTRY_RUNNING: "time.errors.running",
  TIME_PROJECT_ARCHIVED: "time.errors.archived",
  TIMER_NOT_RUNNING: "time.errors.notRunning",
  TIMER_ALREADY_RUNNING: "time.errors.alreadyRunning",
  TIME_RANGE_INVALID: "time.errors.range",
  VERSION_CONFLICT: "errors.conflict",
  PERMISSION_DENIED: "time.errors.forbidden",
  TASK_NOT_FOUND: "time.errors.notFound",
  PROJECT_NOT_FOUND: "time.errors.notFound",
  TIME_ENTRY_NOT_FOUND: "time.errors.notFound",
  [NETWORK_ERROR]: "errors.network",
};

export function timeErrorMessage(error: unknown): MessageId {
  return (isApiError(error) ? MESSAGES[error.code] : undefined) ?? "time.errors.generic";
}
